/* eslint-disable camelcase */
import React from 'react';
import I18n from 'i18n-js';
import { Tour, Checkbox } from 'antd';
import axios from 'axios';
import {
  bool, func, instanceOf, shape,
} from 'prop-types';
import { dont_show_again_path } from 'js-routes/generated/routes';

const ServiceDeskTour = ({
  open = false,
  onClose,
  serviceDeskRef,
  reportIssueRef,
  hasServiceDesk = false,
  hasReportIssue = false,
  dontShowAgain = false,
  setDontShowAgain,
}) => {
  const persistPreference = () => axios.get(dont_show_again_path({
    dont_show_subject: 'dont_show_service_desk_tour',
    dont_show_value: dontShowAgain,
  }));

  const handleClose = () => {
    persistPreference();
    onClose();
  };

  const dontShowAgainCheckbox = (
    <Checkbox
      checked={dontShowAgain}
      onChange={(e) => setDontShowAgain(e.target.checked)}
    >
      {I18n.t('tickets.service_desk_tour.dont_show_again')}
    </Checkbox>
  );

  const buildStep = (key, targetRef) => ({
    title: I18n.t(`tickets.service_desk_tour.${key}.title`),
    description: (
      <>
        <div>{I18n.t(`tickets.service_desk_tour.${key}.description`)}</div>
        <hr />
        {dontShowAgainCheckbox}
      </>
    ),
    target: () => targetRef.current?.closest('.ant-dropdown-menu-item') || targetRef.current,
  });

  // eslint-disable-next-line react-hooks/refs
  const steps = [
    hasReportIssue && buildStep('report_issue', reportIssueRef),
    hasServiceDesk && buildStep('service_desk', serviceDeskRef),
  ].filter(Boolean);

  return (
    <Tour
      open={open}
      onClose={handleClose}
      onFinish={handleClose}
      steps={steps}
      placement="left"
      zIndex={1100}
      rootClassName="service-desk-tour"
    />
  );
};

ServiceDeskTour.propTypes = {
  open: bool,
  onClose: func.isRequired,
  serviceDeskRef: shape({ current: instanceOf(Element) }).isRequired,
  reportIssueRef: shape({ current: instanceOf(Element) }).isRequired,
  hasServiceDesk: bool,
  hasReportIssue: bool,
  dontShowAgain: bool,
  setDontShowAgain: func.isRequired,
};

export default ServiceDeskTour;
/* eslint-enable camelcase */
